import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgDollarSlashIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g stroke="currentColor">
      <path
        fill="currentColor"
        d="m30.556 40.92-.472-.027a20.3 20.3 0 0 1-3.992-.631v-2.135q1.144.295 2.313.467v.001q1.317.2 2.649.201a4.82 4.82 0 0 0 2.893-.66l.059-.035.047-.049a3.06 3.06 0 0 0 .832-2.424 3.34 3.34 0 0 0-.488-2.011l-.034-.053-.045-.044a3.5 3.5 0 0 0-1.814-.929l-2.466-.63-.009-.002-.008-.002-.315-.075a8.1 8.1 0 0 1-2.082-.868 3.4 3.4 0 0 1-1.268-1.5 6.3 6.3 0 0 1-.43-2.537l.002-.025-.001-.024a4.7 4.7 0 0 1 1.058-3.267 4.97 4.97 0 0 1 3.1-1.329l.472-.027V19.3h2.174v2.95l.459.038q1.526.13 3.02.456v2.14a20 20 0 0 0-2.081-.373q-1.156-.158-2.323-.164a4.6 4.6 0 0 0-2.62.533l-.059.031-.048.046a2.4 2.4 0 0 0-.732 1.989c-.053.68.14 1.358.547 1.907l.035.046.043.037c.582.495 1.29.819 2.046.937l2.148.517h.003a8.5 8.5 0 0 1 2.365.946 3.43 3.43 0 0 1 1.305 1.549c.322.847.47 1.75.436 2.655v.025l.001.023a5.63 5.63 0 0 1-1.062 3.632 4.93 4.93 0 0 1-3.042 1.548l-.441.052v3.08h-2.175z"
      />
      <path
        fill="currentColor"
        d="M31.6 6.5A25.13 25.13 0 0 1 56.69 30.978l.01.623A25.1 25.1 0 1 1 31.134 6.504zm8.763 3.943A22.9 22.9 0 1 0 31.6 54.5a22.93 22.93 0 0 0 22.9-22.9 22.9 22.9 0 0 0-14.137-21.157Z"
      />
      <path strokeWidth={4} d="m15.1 49.1 33.5-34.5" />
    </g>
  </svg>
)
export default SvgDollarSlashIcon
